import { css } from "@emotion/react";

export const LoadingTable = () => {
  return (
    <div css={rootStyle}>
      読込中
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </div>
  );
};

const rootStyle = css`
  width: 100%;
  padding: 1rem;

  text-transform: uppercase;

  span {
    display: inline-block;
    color: #000;

    font-weight: bold;
    animation: rotate 2s infinite linear;
  }

  span:nth-child(2) {
    animation-delay: 0.1s;
  }

  span:nth-child(3) {
    animation-delay: 0.2s;
  }

  span:nth-child(4) {
    animation-delay: 0.3s;
  }

  @keyframes rotate {
    70% {
      transform: rotateX(0deg);
    }

    100% {
      transform: rotateX(360deg);
    }
  }
`;
